import axios from "axios"


import { hvnUriRoot } from "../core/defines"

const apiRoot= "https://api.marineblue-g.com"
const shopID = "m_marineblue"

export default function useCastEffect(){

    const fetchCasts=async({newface=false, take=0})=>{

        // 新人
        const nfOnly= newface===true
                        ? "&m=newface"
                        : ""
                        
        // 取得上限 (現状topページの新人のみ)
        const takes= take>0
                        ? "&col="+ take
                        : ""


        const res = await axios.get(`${apiRoot}/v2/casts?s=${shopID}${nfOnly}${takes}`)
            .then(r=>{

                return {result: true, data: r.data}
            })
            .catch(e=>{

                return {result: false, data: []}

            })

        return res
    }

    const fetchSchedule=async({date=null})=>{

        // 日付 Y-m-d形式で代入すること
        const params= date===null
                        ? ""
                        : "&d="+ date

        const res = await axios.get(`${apiRoot}/v2/schedule?s=${shopID}${params}`)
            .then(r=>{
                return {result: true, data: r.data}
            })
            .catch(e=>{
                return {result: false, data: []}
            })

        return res
    }

    const fetchProfile=async({castID})=>{

        const res = await axios.get(`${apiRoot}/v2/profile?s=${shopID}&c=${castID}`)
            .then(r=>{
                return {result: true, data: r.data}
            })
            .catch(e=>{
                return {result: false, data: []}
            })

        return res
    }



    const fetchCastDiary =async(castHvnId)=>{

        const target= `${hvnUriRoot}/girlid-${castHvnId}/diary/`

        const res=await axios({
                method: "get",
                url: `${apiRoot}/v2/diary_cast?t=` + target
            })
            .then((res=>{
                // console.log(res)
                return(res.data)
            }))
            .catch(e=>{
                return []
            })

        return res
    }



    return {
        fetchCasts, fetchSchedule, fetchProfile,
        fetchCastDiary
    }
}